import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import GenericCrudModule from "@/components/GenericCrudModule";
import ContextButton from "@/components/ContextButton";
import ThreeQPageHeader from "@/components/ThreeQPageHeader";

const STATUT_COLORS = { actif: "#1D9E75", obsolete: "#A1A1AA", a_revoir: "#EF9F27" };

export default function Controles() {
  const { t } = useTranslation();
  return (
    <>
      <ThreeQPageHeader endpoint="/workspace/controles/top-priority" className="mb-4" />
      <GenericCrudModule
      module={{
        path: "controles",
        title: t("saas.controles.title"),
        overline: t("saas.controles.overline"),
        subtitle: t("saas.controles.subtitle"),
        accent: "#378ADD",
        icon: ShieldCheck,
        dataTestId: "controles",
      }}
      fields={[
        { key: "nom", label: t("saas.controles.field_nom"), required: true, span: 2,
          placeholder: t("saas.controles.field_nom_ph") },
        { key: "type", label: t("saas.controles.field_type"), type: "select",
          options: ["preventif", "detectif", "correctif"].map((v) => ({ value: v, label: t(`saas.controles.types.${v}`) })),
          default: "preventif", required: true },
        { key: "frequence", label: t("saas.controles.field_frequence"), type: "select", default: "mensuel",
          options: ["quotidien", "hebdo", "mensuel", "trimestriel", "annuel"].map((v) => ({ value: v, label: t(`saas.controles.frequences.${v}`) })) },
        { key: "owner", label: t("saas.controles.field_owner"), placeholder: t("saas.controles.field_owner_ph") },
        { key: "statut", label: t("saas.controles.field_statut"), type: "select", default: "actif",
          options: ["actif", "obsolete", "a_revoir"].map((v) => ({ value: v, label: t(`saas.controles.statuts.${v}`) })) },
        { key: "efficacite", label: t("saas.controles.field_efficacite"), type: "number", default: 70, max: 100 },
        { key: "commentaire", label: t("saas.controles.field_commentaire"), type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "nom", label: t("saas.controles.col_controle") },
        { key: "type", label: t("saas.controles.field_type"), render: (r) => t(`saas.controles.types.${r.type}`, { defaultValue: r.type }) },
        { key: "frequence", label: t("saas.controles.field_frequence"), render: (r) => t(`saas.controles.frequences.${r.frequence}`, { defaultValue: r.frequence }) },
        { key: "owner", label: t("saas.controles.field_owner") },
        { key: "efficacite", label: t("saas.controles.col_efficacite"), render: (r) => (
          <div className="flex items-center gap-2">
            <div className="w-16 h-1 rounded-full bg-white/5 overflow-hidden">
              <div className="h-full bg-[#378ADD]" style={{ width: `${r.efficacite}%` }} />
            </div>
            <span className="text-xs text-zinc-300">{r.efficacite}%</span>
          </div>
        )},
        { key: "statut", label: t("saas.controles.field_statut"), render: (r) => (
          <span className="text-[10px] px-2 py-0.5 rounded-full font-medium uppercase tracking-wider"
            style={{ background: `${STATUT_COLORS[r.statut]}1A`, color: STATUT_COLORS[r.statut] }}>
            {t(`saas.controles.statuts.${r.statut}`, { defaultValue: r.statut })}
          </span>
        )},
      ]}
      emptyMsg={t("saas.controles.empty_msg")}
      primaryCta={t("saas.controles.primary_cta")}
      headerActions={<ContextButton moduleKey="controles" />}
      kpis={(data) => {
        const items = data.items || [];
        const total = items.length;
        const actifs = items.filter((i) => i.statut === "actif").length;
        const a_revoir = items.filter((i) => i.statut === "a_revoir").length;
        const eff = items.length ? Math.round(items.reduce((s, i) => s + (i.efficacite || 0), 0) / items.length) : 0;
        return [
          { label: t("saas.controles.kpi_total"), value: total },
          { label: t("saas.controles.kpi_actifs"), value: actifs, color: "#1D9E75" },
          { label: t("saas.controles.kpi_a_revoir"), value: a_revoir, color: "#EF9F27", hint: t("saas.controles.kpi_a_revoir_hint") },
          { label: t("saas.controles.kpi_eff"), value: `${eff}%`, color: eff >= 70 ? "#1D9E75" : eff >= 50 ? "#EF9F27" : "#E24B4A" },
        ];
      }}
    />
    </>
  );
}
